'use es6';

import createAction from 'flux-actions/createAction';
import { RECIEVED_SMART_CONTENT_DATA_CHECK, REQUESTED_SMART_CONTENT_DATA_CHECK, REQUESTED_SMART_CONTENT_DATA_CHECK_FAILED, FETCH_SMART_CONTENT_DATA_CHECK } from './ActionTypes';
export const requestedSmartContentDataCheck = createAction(REQUESTED_SMART_CONTENT_DATA_CHECK);
export const requestedSmartContentDataCheckSucceeded = createAction(RECIEVED_SMART_CONTENT_DATA_CHECK, data => ({
  data
}));
export const requestedSmartContentDataCheckFailed = createAction(REQUESTED_SMART_CONTENT_DATA_CHECK_FAILED, error => ({
  error
}));
export const fetchSmartContentDataCheck = createAction(FETCH_SMART_CONTENT_DATA_CHECK, analyticsPageId => ({
  analyticsPageId
}));